import { render, staticRenderFns } from "./PriceInput.vue?vue&type=template&id=cabe25fe&scoped=true&"
import script from "./PriceInput.vue?vue&type=script&lang=js&"
export * from "./PriceInput.vue?vue&type=script&lang=js&"
import style0 from "./PriceInput.vue?vue&type=style&index=0&id=cabe25fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cabe25fe",
  null
  
)

export default component.exports